import React, { FC } from "react";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export interface ActionButtonProp {
  returnToList: Function;
  saveAttachments: Function;
  labels: any;
  fileError: boolean;
}

const ActionButtons: FC<ActionButtonProp> = (props) => {
  const {
    returnToList = () => {},
    saveAttachments = () => {},
    labels,
    fileError,
  } = props;

  return (
    <Grid item xs={5}>
      <Box display={"flex"} justifyContent="right">
        <Box pr={2}>
          <Button
            id="buttonEventMarkerCancelCreate"
            className="eventMarkerButton eventMarkerButtonLg eventMarkerCancelButton"
            variant="outlined"
            onClick={(e) => {
              returnToList();
              e.preventDefault();
            }}
          >
            {labels["Buttons.Cancel.Text"]}
          </Button>
        </Box>
        <Box>
          <Button
            id="buttonEventMarkerSaveCreate"
            className="eventMarkerButton eventMarkerButtonLg"
            variant="contained"
            onClick={(e) => {
              saveAttachments();
              e.preventDefault();
            }}
            disabled={fileError ? true : false}
          >
            {labels["Buttons.Save.Text"]}
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default ActionButtons;
